<template>
  <div class="hyxy-dialog-wrap">
    <CvipDialog @btnClick="close()" @close="close()" :title="title" :btnTxt="btnTxt" :stopPrevent="stopPrevent">
      <div class="hyxy-agreement">
        <div class="hyxy-content">
          <div class="hyxy-text">欢迎您使用58招聘求职金卡服务。</div>
          <div class="hyxy-text">《58招聘求职金卡服务协议》是您在使用58招聘求职金卡服务时必须遵守的协议（以下简称“本协议”）。您勾选同意或实际接受了58（指58同城（www.58.com）的网络服务提供者，包括58同城网（www.58.com）的所有者及其关联服务提供方）招聘求职金卡服务，就表示您已接受了本协议的全部约定并愿意受其约束。<b class="blod">请您仔细阅读本协议，充分理解本协议的各条款内容。如果您不同意本规则或其中任何条款约定，应立即停止使用58求职金卡服务。如发生纠纷，您不能以未经仔细阅读为由进行抗辩。甲方除应遵守本协议约定外，还应遵守58同城线上《58同城使用协议》（http://about.58.com/home/announcement.html）、《58推广用户服务协议》（http://tuiguang.58.com/agreement）、《58同城隐私权条款》（http://about.58.com/395.html）的相关规定。</b></div>
        </div>
        <div class="hyxy-content">
          <div class="hyxy-title">一、招聘求职金卡服务的内容</div>
          <div class="hyxy-text">1、您首先应该清楚地了解58招聘求职金卡服务的业务模式。您购买招聘求职金卡服务套餐后即成为58同城的黄金会员用户。在招聘求职金卡套餐有效期内，您将根据所购买套餐的类型享有以下几项或全部求职特权，包括应聘优先、简历置顶、投递特权、免费刷新、黄金亮点、竞争力分析、面试无忧、尊贵标识、专属客服等，具体以58同城平台公示为准。</div>
          <div class="hyxy-text">2、您可通过在线支付或用您在58同城开立的交易宝账户、58现金账户（具体以58同城平台公示的为准）内的余额购买招聘求职金卡服务套餐。<b class="blod">您知悉并同意，因“58招聘求职金卡服务”为在线即时服务产品，一经购买开通，非法定情形，您不得擅自要求提前终止服务，否则，您前期已支付的服务费用将被扣除作为违约金以及对58同城已做工作的补偿。</b></div>
        </div>
        <div class="hyxy-content">
          <div class="hyxy-title"><b class="blod">二、面试无忧专有条款</b></div>
          <div class="hyxy-text">您在购买招聘求职金卡服务套餐时可获得58同城额外提供的面试无忧服务，即当您在58同城创建简历且投递简历后5-30天内（具体以申请页面提示为准）包括但不限于通过短信、电话、微聊消息、站内信等方式收到来自招聘单位的面试邀约的，您可以获得赔偿。具体赔偿判别的依据及申请的流程还以下述约定的为准。</div>
          <div class="hyxy-text">1. 赔偿判别依据</div>
          <div class="hyxy-text">当您符合以下所有条件时，将获得按照本条款第2项所述的标准的赔偿。</div>
          <div class="hyxy-text">（1）您购买求职金卡且截至申请赔付时，您发布的简历状态需保持一直为“公开”；</div>
          <div class="hyxy-text">（2）您购买求职金卡且截至申请赔付时，您在58平台的求职状态显示为“求职中”；</div>
          <div class="hyxy-text">（3）在招聘求职金卡服务有效期内<b class="blod">必需要使用完毕会员金卡提供的所有求职的特权功能（如投递简历、刷新简历、置顶简历、微聊特权等功能，具体以58同城届时展示的功能为准）；</b></div>
          <div class="hyxy-text">（4）在招聘求职金卡服务有效期内首次投递简历时起算，在5-30个自然日内您未收到过企业的任何面试邀请、电话或微聊信息；</div>
          <div class="hyxy-text">（5）同一用户（包括但不限于同一ID会员、同一身份证、同一账户、同一IP、同一手机或同一电脑操作均视为同一用户）只能申请赔付1次，即无论您申请赔付的结果是被拒绝赔付还是同意赔付。鉴于此，58同城提示您，在申请赔付前需详细认真的阅读本协议，以防您申请的结果不符合赔付要求。</div>
          <div class="hyxy-text">（6）在58平台完成“我的认证”-“个人认证”-<b class="blod">“人脸认证”</b>里完成实名认证且简历名字需与认证通过的身份证姓名一致；</div>
          <div class="hyxy-text">（7）所购买的会员卡有效期内投递30个不同的真实企业（具体判定标准以58同城认定的为准）的岗位；</div>
          <div class="hyxy-text">（8）简历完整度<b class="blod">（以平台显示的完整度为准）</b>需达到90%以上；</div>
          <div class="hyxy-text">（9）国家法定节假日提交的赔付申请，58同城将在节假日后的工作日进行处理；</div>
          <div class="hyxy-text"><b class="blod">（10）以上符合条件的用户会进入人工复核，若经人工核验发现用户存在虚假求职（1、包括但不限于学历、薪资或职位类别等信息与招聘方或一般公众理解的要求相差较多；2、涉嫌虚假求职；3、涉嫌通过黑产等非法利益链条而使用求职金卡；4、未使用金卡权益，非常规工作日时间内投递等；5、涉嫌诈骗嫌疑（最终判定的标准以58同城为准），基于58同城已经在平安投保平台责任险，58同城会连同平安保险公司拉黑处理；</b></div>
          <div class="hyxy-text">2. 申请流程</div>
          <div class="hyxy-text">（1）当您满足本条款第1项的赔付条件时，需在招聘求职金卡有效期内，在线点击“申请赔付”，由58同城判别您是否符合上述赔付条件，如逾期点击“申请赔付”的，58同城将不再提供此求职保障服务；</div>
          <div class="hyxy-text">（2）如经判别符合，您需要按照58同城的要求如实提供信息资料（包括但不限姓名、身份证号、手机号、银行卡信息等），因您填写的信息有误或不真实，导致您未收到赔付款项的，58同城不承担任何责任。如经判别不符合的，您将无法获得赔偿。因判别是否符合出现争议的，最终以58同城判别的为准。</div>
          <div class="hyxy-text">（3）赔付金额具体以58招聘求职金卡服务套餐购买页面会员特权介绍中展示的为准。</div>
          <table class="hyxy-table">
            <tr>
              <td></td>
              <td v-for="mealName in hyxyMealInfo">{{ mealName.name }}</td>
            </tr>
            <tr>
              <td>卡面价值（元）</td>
              <td v-for="mealName in hyxyMealInfo">{{ mealName.price }}</td>
            </tr>
            <tr>
              <td>赔偿金额（元）</td>
              <td v-for="mealName in hyxyMealInfo">{{ mealName.compensate }}</td>
            </tr>
          </table>
          <div class="hyxy-text">（4）平安偿付能力数据和综合评级结果的链接：</div>
          <a class="hyxy-link-pingan" href="http://property.pingan.com/gongkaixinxipilu/changfunenglixinxipilubaogao.shtml" target="_blank">http://property.pingan.com/gongkaixinxipilu/changfunenglixinxipilubaogao.shtml</a>
        </div>
        <div class="hyxy-content">
          <div class="hyxy-title">三、招聘求职金卡服务规则</div>
          <div class="hyxy-text">1、您应按照58同城页面显示信息字段填写或完善您的求职意向信息，且保证所填写的信息真实、有效、合法、不得 冒用、盗用、仿造、变造。如因您提供的信息不符合上述要求，58同城有权拒绝为您提供招聘求职金卡服务。</div>
          <div class="hyxy-text"><b class="blod">2、您知悉并确认58同城提供的招聘求职金卡服务中的竞争力分析服务，仅为您的求职过程中提供参考，58同城在任何情况下并不对竞争力分析结果的真实性、准确性、有效性、客观性或相应的任何后果（包括但不限于您依据分析结果、资料或服务而做出的决定或者采取的行动等）承担任何责任。</b></div>
          <div class="hyxy-text"><b class="blod">3、您知悉并授权58同城有权通过您填写的简历信息请第三方认证机构核实您的身份信息以便完成您的“个人认证”服务。</b></div>
          <div class="hyxy-text">4、您知悉58同城仅对您填写的信息进行形式审核，如服务开通后经由第三方（包括但不限于与您有交易的用户、国家监管机关或司法机关的通知、裁决等）投诉举证您存在资质冒用、伪造等情形 且您也未能及时自证的，58同城有权冻结您的账号及至终止提供服务并要求您向58同城承担违约责任。</div>
          <div class="hyxy-text"><b class="blod">5、您知悉58同城仅为互联网信息发布平台，推荐给您的招聘信息来源于58同城网站上推广用户自行发布的招聘信息。58同城不对推荐给您的招聘单位的信息的真实、合法性承担任何责任也不对推荐的行为做效果承诺，您应自行谨慎选择招聘单位，最终是否录用以您自行与招聘单位进行沟通确认的为准。如您与招聘单位发生纠纷，您需与招聘单位自行协商解决，58同城不承担任何责任。</b></div>
        </div>
        <div class="hyxy-content">
          <div class="hyxy-title">四、其他</div>
          <div class="hyxy-text"><b class="blod">1、58同城有权根据国家法律法规的更新、产品和服务规则的调整需要不时地制订、修改本协议涉及的招聘求职金卡服务及求职保障服务，并以网站公示的方式进行公示。如您继续使用58同城招聘求职金卡服务的，即表示您接受经修订的规则和条款。如发生有关争议时，以最新的58招聘求职金卡服务协议为准。</b></div>
          <div class="hyxy-text">2、<b class="blod">本规则采用电子文本形式制成</b>，由用户通过58同城平台签署并永久保存在58同城为此设立的专用服务器上备查，同时，双方均认可该形式的规则效力。</div>
          <div class="hyxy-text">3、本规则的订立、执行、解释及争议解决均适用中华人民共和国法律。因本规则的履行或本规则引起的任何争议双方应通过友好协商方式解决，如无法通过友好协商方式解决的，双方一致同意通过<b class="blod">北京市朝阳区人民法院</b>以诉讼方式解决。</div>
        </div>
      </div>
    </CvipDialog>
  </div>
</template>

<script>
import CvipDialog from "./common/CvipDialog";
import { mapGetters } from 'vuex';

export default {
  name: 'hyxyDialog',
  props: {
    stopPrevent: {
      type: Boolean,
      default: true
    }
  },
  components: {
    CvipDialog
  },
  data () {
    return {
      title: '58招聘求职金卡服务协议',
      btnTxt: '我知道了',
      hyxyMealInfo: [
        {
          name:'7天体验版',
          price: 18,
          compensate: 100,
        },
        {
          name:'30天基础版',
          price: 28,
          compensate: 160,
        },
        {
          name:'30天升级版',
          price: 60,
          compensate: 460,
        },
        {
          name:'半年卡',
          price: 60,
          compensate: 880,
        }
      ]
    }
  },
  created () {
    window.clickLog && window.clickLog('from=pc-cvip-hyxy-tanchuang-show-new')
    this.initMealName();
  },
  methods: {
    close () {
      window.clickLog && window.clickLog('from=pc-cvip-tqtc-hyxy-close-new')
      this.$emit('closeDialog')
    },
    initMealName() {
      this.mealInfo.payset.forEach((mealItem, index) => {
        this.hyxyMealInfo[index].name = mealItem.versionName;
        this.hyxyMealInfo[index].price = mealItem.benefitsPrice;
      })
    },
  },
  computed: mapGetters({
			mealInfo: 'mealInfo',					// 购买套餐信息
  })
}
</script>

<style lang="scss" scoped>
.tit {
  margin-top: 80px;
}
.blod {
  color: #333;
}
.hyxy-bg {
  width: 606px;
  height: 290px;
  margin: 20px auto 0;
  overflow: hidden;
}
.hyxy-bg-img {
  width: 606px;
  height: 290px;
}
.des-in {
  font-size: 14px;
  color: #aaa;
}
.des-use {
  width: 100%;
  display: inline-block;
  text-align: center;
}
.tit {
  margin: 55px 0 8px;
  font-size: 24px;
  color: #333;
  line-height: 33px;
  text-align: center;
}
.tit-names {
  font-size: 24px;
  color: #D4B277;
  line-height: 33px;
}

.hyxy-agreement {
  overflow-y: scroll;
  padding-right: 40px;
  width: 100%;
  height: 357px;
}
.hyxy-agreement::-webkit-scrollbar {
  background: rgba(0, 0, 0, 0);
  width: 10px;
  height: 4px;
}
.hyxy-agreement::-webkit-scrollbar-thumb {
  background: rgba(37, 36, 36, 0.4);
  border-radius: 5px;
}
.hyxy-content {
  .hyxy-title {
    padding: 6px 0;
    color: #333;
    line-height: 24px;
    font-family: PingFangSC-Medium;
  }
  .hyxy-text {
    color: #aaa;
    line-height: 22px;
    text-align: justify;
  }
  .hyxy-table {
    margin: 8px 0;
    width: 100%;
    border: 1px solid #ccc;
    color: #aaa;
    table-layout: fixed;
    td {
      border: 1px solid #ccc;
      height: 33px;
      text-align: center;
    }
  }
  .hyxy-link-pingan {
    display: block;
    margin: 5px;
    color: #e6ca98;
  }
}
</style>



// WEBPACK FOOTER //
// HyxyDialog.vue?613442a7